import React from "react";
import ReactGA from "react-ga4";
import styles from "./carStatistics.scss";
import { CarStatisticsItem } from "./CarStatisticsItem";
import { BRAND_DATA } from "./statistics";
import { Link } from "react-router-dom";
import { CategoryNameHr, ModuleNameHr, PageRoute, QueryParam } from "../../../models";
import { scrollToTop, stringifyURI } from "../../../services";


export const CarStatistics = () => {

  const handleClick = (brand) => {
    ReactGA.event({
      category: "Popularne marke i modeli - marka kliknuta",
      action: "Click",
      label: `${brand}`,
    });

        scrollToTop();
    
  }


  return (
    <div className={styles.container}>
      <div className={styles.title}>Popularne marke i modeli</div>
      <div className={styles.brandsGrid}>
        {BRAND_DATA.map((item) => (
          <div className={styles.brandCard}>
            <div className={styles.brandHeader}>
              <Link
                to={`/${ModuleNameHr.vehicles}/${CategoryNameHr.car}${PageRoute.search}${stringifyURI({
                  category: CategoryNameHr.car,
                  includeMakeIds: [item.makeId],
          module: ModuleNameHr.vehicles,
                }, QueryParam.searchQuery)}`}
                onClick={() => handleClick(item.brand)}
              >
                <span className={styles.brandName}>{item.brand}</span>
              </Link>
            </div>
            <ul className={styles.modelList}>
              {item.models.map((model) => (
                <CarStatisticsItem key={model.name} brand={item.brand} model={model} />
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/containers/ModulePage/CarStatistics/CarStatistics.tsx